/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/react-in-jsx-scope */
import { message } from 'antd';
import { getMatchTitleList, saveMatchTitle } from '../services/upload/student';
import { setSpinProps } from '../../../../utils/utils';

const initState = () => {
  return {
    /**
     * 数据列表
     * attributeType: 字段类型   String
     * columnNum: 字段序号  String
     * excelTitle:  excel中的字段名  String
     * mappingTitle: 系统中的映射字段名  String
     * matchTitle: 不知道干什么用的 String
     * status: 字段匹配状态 mismatch：未匹配 match： 智能匹配 manualMatch： 手动匹配 add：新增  String
     * values: table值列表  Array<String>
     */
    titles: [],
    /**
     * 可以匹配的字段列表
     * attributeName: 字段名 String
     * attributeSign: 标识  String
     * attributeType: 字段类型 String
     * isRequired: 是否必选 String
     */
    matchTitleList: [],
    isRequiredList: [], // 必填项key值的集合
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
  };
};

export default {
  namespace: 'countyStudentUpload',

  state: initState(),

  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(({ pathname, query }) => {
        const { type, taskId } = query;
        if (
          pathname.match(/^\/countyContacts\/import$/) &&
          type === 'student'
        ) {
          dispatch({
            type: 'fetchMatchTitleList',
            params: { taskId },
          });
        }
      });
    },
  },

  effects: {
    // 获取可以匹配的字段列表
    *fetchMatchTitleList({ params }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { titles = [] } = yield call(getMatchTitleList, params);

        const newTitles = titles.map(item => ({
          ...item,
          name: item.attributeName,
        }));
        // 必填项列表
        const isRequiredList = titles
          .filter(({ isRequired }) => isRequired !== false)
          .map(({ attributeName }) => attributeName);

        yield put({
          type: 'save',
          payload: { isRequiredList, matchTitleList: newTitles, spinProps: { spinning: false } },
        });
      } catch (error) {
        console.error(error)
        yield setSpinProps({ put });
      }
    },
    *fetchSubmit({ params, callback }, { call, put }) {
      try {
        yield setSpinProps({
          put,
          spinning: true,
          tip: '提交中...',
          sameNameUserModalVisible: false,
        });

        const { columns = [], taskId } = params;

        // 先整合需要提交的字段
        const newColumns = columns.map(({ excelTitle, isMobile, mappingTitle, status }) => ({
          excelTitle,
          isMobile,
          matchTitle: mappingTitle,
          status,
        }));

        // 新增数据
        const addTitles = newColumns.filter(({ status = '' }) => status === 'add');

        // 忽略的数据
        const ignoreTitles = newColumns.filter(({ status = '' }) => status === 'ignore');

        // 手动匹配
        const manualMatchTitles = newColumns.filter(({ status = '' }) => status === 'manualMatch');

        // 智能匹配
        const mappingTitles = newColumns.filter(({ status = '' }) => status === 'match');

        yield call(saveMatchTitle, {
          addTitles,
          mappingTitles,
          manualMatchTitles,
          ignoreTitles,
          taskId,
        });

        // message.success('导入成功');

        if (callback) {
          callback();
        }
      } catch (error) {
        console.error(error)
        yield setSpinProps({ put });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    reset() {
      return { ...initState() };
    },
  },
};
